import React, { useContext, useEffect, useState } from 'react';
import { Heading, Container, HStack, Box, Button } from '@chakra-ui/react';
import { HttpContext } from '../context/HttpContext';
import PaymentList from '../components/payments/PaymentList';
import Search from '../common/UIcomponents/SearchList';
import { usePaginator } from 'chakra-paginator';
import { AuthContext } from '../context/AuthContext';
import PaymentsTotalAndPending from '../components/payments/PaymentsTotalAndPending';
import SageRestartSync from '../components/vendors/SageRestartSync';
import FilterPayments from '../components/payments/FilterPaymentDropdown';
import { INITIAL_PAGE_SIZE } from '../util/consts';
import { DownloadIcon } from '../assets/iconsComponents/downloadIcon';
import { useHistory, useLocation } from 'react-router-dom';

export default function PortalPayments() {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const clearedOrderBy = {
    totalGross: null,
    totalNet: null,
    totalVat: null,
    status: null,
    number: null,
    referenceNumber: null,
    fromName: null,
    date: null,
    dueDate: null,
    paymentDate: null,
  };
  const initialOrderBy = {
    totalGross: null,
    totalNet: null,
    totalVat: null,
    status: null,
    number: null,
    referenceNumber: null,
    fromName: null,
    date: null,
    dueDate: null,
    paymentDate: null,
  };

  const [state, setState] = useState({
    loading: true,
    status: 'idle',
    total: 0,
    paidPayments: [],
    pendingPayments: [],
    invoices: [],
    error: null,
  });
  const { invoices, total, paidPayments, pendingPayments } = state;

  const [order, setOrder] = useState(initialOrderBy);
  const [term, setTerm] = useState(searchParams.get('search') || '');
  const [filterStatus, setFilterStatus] = useState(searchParams.get('status') || '');
  const [filterDueDateFrom, setFilterDueDateFrom] = useState(
    searchParams.get('paymentDueDateFrom') || ''
  );
  const [filterDueDateTo, setFilterDueDateTo] = useState(
    searchParams.get('paymentDueDateTo') || ''
  );
  const [filterPaymentDateFrom, setFilterPaymentDateFrom] = useState(
    searchParams.get('paymentDateFrom') || ''
  );
  const [filterPaymentDateTo, setFilterPaymentDateTo] = useState(
    searchParams.get('paymentDateTo') || ''
  );

  const { authAxios } = useContext(HttpContext);
  const auth = useContext(AuthContext);

  const { pagesQuantity, currentPage, setCurrentPage, pageSize, setPageSize, offset } =
    usePaginator({
      total: total,
      initialState: {
        pageSize: INITIAL_PAGE_SIZE,
        currentPage: 1,
        isDisabled: false,
      },
    });

  function getSortingQuery(order) {
    if (order.totalGross) {
      return `&sort=totalGross&direction=${order.totalGross}`;
    }
    if (order.totalNet) {
      return `&sort=totalNet&direction=${order.totalNet}`;
    }
    if (order.totalVat) {
      return `&sort=totalVat&direction=${order.totalVat}`;
    }
    if (order.status) {
      return `&sort=status&direction=${order.status}`;
    }
    if (order.number) {
      return `&sort=number&direction=${order.number}`;
    }
    if (order.referenceNumber) {
      return `&sort=referenceNumber&direction=${order.referenceNumber}`;
    }
    if (order.fromName) {
      return `&sort=fromName&direction=${order.fromName}`;
    }
    if (order.date) {
      return `&sort=date&direction=${order.date}`;
    }
    if (order.dueDate) {
      return `&sort=dueDate&direction=${order.dueDate}`;
    }
    if (order.paymentDate) {
      return `&sort=paymentDate&direction=${order.paymentDate}`;
    }

    return '';
  }

  useEffect(() => {
    const params = new URLSearchParams();
    if (filterStatus) params.set('status', filterStatus);
    if (filterDueDateFrom) params.set('paymentDueDateFrom', filterDueDateFrom);
    if (filterDueDateTo) params.set('paymentDueDateTo', filterDueDateTo);
    if (filterPaymentDateFrom) params.set('paymentDateFrom', filterPaymentDateFrom);
    if (filterPaymentDateTo) params.set('paymentDateTo', filterPaymentDateTo);
    if (term) params.set('search', term);
    history.replace({ pathname: location.pathname, search: params.toString() });
  }, [
    history,
    location.pathname,
    filterStatus,
    filterDueDateFrom,
    filterDueDateTo,
    filterPaymentDateFrom,
    filterPaymentDateTo,
    term,
  ]);

  useEffect(() => {
    const getPortalData = async () => {
      try {
        setState({
          ...state,
          status: 'pending',
        });
        const sort = getSortingQuery(order);
        let url = `invoices?limit=${pageSize}&offset=${offset}${sort}`;
        if (term.trim()) url += `&search=${encodeURIComponent(term)}`;
        if (filterStatus) url += `&status=${filterStatus}`;
        if (filterDueDateFrom && filterDueDateTo) {
          url += `&paymentDueDateFrom=${filterDueDateFrom}&paymentDueDateTo=${filterDueDateTo}`;
        }
        if (filterPaymentDateFrom && filterPaymentDateTo) {
          url += `&paymentDateFrom=${filterPaymentDateFrom}&paymentDateTo=${filterPaymentDateTo}`;
        }
        const res = await authAxios.get(url);
        setState({
          loading: false,
          invoices: res.data?.data ?? [],
          total: res.data?.meta?.total ?? 0,
          paidPayments: res.data?.meta?.paidPayments ?? [],
          pendingPayments: res.data?.meta?.pendingPayments ?? [],
          status: 'resolved',
        });
      } catch (onError) {
        console.log(onError);
        setState({
          ...state,
          status: 'rejected',
          loading: false,
          error: 'Something went wrong',
        });
      }
    };

    getPortalData();
  }, [
    authAxios,
    currentPage,
    pageSize,
    offset,
    order,
    term,
    filterStatus,
    filterDueDateFrom,
    filterDueDateTo,
    filterPaymentDateFrom,
    filterPaymentDateTo,
  ]);

  function updateOrderBy(key, value) {
    setOrder({ ...clearedOrderBy, [key]: value });
    setCurrentPage(1);
  }

  function updateFilterStatus(status) {
    setFilterStatus(status);
    setCurrentPage(1);
  }

  function updateFilterDueDate(from, to) {
    setFilterDueDateFrom(from);
    setFilterDueDateTo(to);
    setCurrentPage(1);
  }

  function updateFilterPaymentDate(from, to) {
    setFilterPaymentDateFrom(from);
    setFilterPaymentDateTo(to);
    setCurrentPage(1);
  }

  function clearAllFilters() {
    setFilterStatus('');
    setFilterDueDateFrom('');
    setFilterDueDateTo('');
    setFilterPaymentDateFrom('');
    setFilterPaymentDateTo('');
    setCurrentPage(1);
  }

  const handlePageChange = (nextPage) => {
    setCurrentPage(nextPage);
  };

  const handlePageSizeChange = (event) => {
    const pageSize = Number(event.target.value);
    setPageSize(pageSize);
    setCurrentPage(1);
  };

  function updateTerm(term) {
    setCurrentPage(1);
    setTerm(term);
  }

  const handleCsvDownload = async () => {
    try {
      const sort = getSortingQuery(order);
      let csvUrl = `invoices?limit=${pageSize}&offset=${offset}${sort}`;
      if (term.trim()) csvUrl += `&search=${encodeURIComponent(term)}`;
      if (filterStatus) csvUrl += `&status=${filterStatus}`;
      if (filterDueDateFrom && filterDueDateTo) {
        csvUrl += `&paymentDueDateFrom=${filterDueDateFrom}&paymentDueDateTo=${filterDueDateTo}`;
      }
      if (filterPaymentDateFrom && filterPaymentDateTo) {
        csvUrl += `&paymentDateFrom=${filterPaymentDateFrom}&paymentDateTo=${filterPaymentDateTo}`;
      }
      csvUrl += `&export=true`;
      const response = await authAxios.get(csvUrl, {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'text/csv; charset=UTF-8' });
      const url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.href = url;
      a.download = 'invoices.csv';
      a.click();
    } catch (onError) {
      console.log(onError);
    }
  };

  return (
    <Container w="100%" maxWidth="100%" pt={4} pr={10} pl={10} pb={14}>
      {auth.isFinance() && auth.getAccessToken() && <SageRestartSync />}
      <Box mt="30px">
        <PaymentsTotalAndPending
          paidPayments={paidPayments}
          pendingPayments={pendingPayments}
        />
      </Box>

      <HStack justifyContent="space-between">
        <Heading as="h2" size="lg" textAlign="left" fontWeight="700" pt={2} mb={0}>
          Payments
        </Heading>
        <Box display="flex" flexDirection="row" pt={1}>
          {auth.isFinance() && (
            <Button
              leftIcon={<DownloadIcon width="17px" color="#fff" height="19px" />}
              colorScheme="brand"
              borderRadius="8px"
              fontSize="14px"
              fontWeight="500"
              pt="18px"
              pb="18px"
              _hover={state?.invoices?.length === 0 ? null : { bg: '#000' }}
              _expanded={{ bg: 'black', color: 'white' }}
              _focus={{ boxShadow: 'none' }}
              onClick={handleCsvDownload}
              disabled={state?.invoices?.length === 0}
              mr="1rem"
            >
              Download (.csv)
            </Button>
          )}
          <Search updateTerm={updateTerm} initialValue={term} />
          <Box width="15px" />
          <FilterPayments
            clearAllFilters={clearAllFilters}
            updateFilterStatus={updateFilterStatus}
            updateFilterDueDate={updateFilterDueDate}
            updateFilterPaymentDate={updateFilterPaymentDate}
          />
        </Box>
      </HStack>
      <PaymentList
        loading={state.loading}
        invoices={invoices}
        handlePageSizeChange={handlePageSizeChange}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
        pagesQuantity={pagesQuantity}
        isCampaign={auth.isCampaignManager()}
        isSupplier={auth.isSupplier()}
        isFinance={auth.isFinanceManager()}
        isPodLeader={auth.isPodLeader()}
        orderBy={order}
        updateOrderBy={updateOrderBy}
      />
    </Container>
  );
}
